<template>
  <div>
    <multiselect
      v-model="inputValue"
      :options="options"
      @input="setValue"
      :multiple="true"
      selectLabel=""
      selectedLabel="«"
      deselectLabel=""
      placeholder=""
      :close-on-select="false"
    >
      <template slot="tag" slot-scope="{ option, remove }">
        <span class="badge badge-primary mr-1">
          <span class="text-truncate mr-1 mb-1">
            {{ option }}
          </span>
          <span class="custom__remove badge" @mousedown.prevent.stop="remove(option)"> x </span>
        </span>
      </template>
    </multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect
  },
  props: ['labelTitle', 'options', 'modelValue'],
  emits: ['setValue'],
  data() {
    return {
      inputValue: this.modelValue
    };
  },
  watch: {
    modelValue() {
      this.inputValue = this.modelValue;
    }
  },
  methods: {
    setValue() {
      this.$emit('setValue', this.inputValue);
    }
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
